import React from "react";

const LeftContactInputSection1 = (props) => {
  const { Data, setData, fullData, title } = props;
  console.log(Data, "idmfi", title);
  // itna sa smj nhi aaya hn
  // issfile m error h iss file m data naam se koi chiz nhi h ka huakuch ni ab y dekhh chl kuch nhi kaam kr jaega
  // haa y dekh y ek component teen baar import kiya h aur teeno m dekh rhi ho toh value hamehsa same jaa rhi h toh thosa dimaag lgaye toh dekh
  return (
    <input
      className="mx-4  mt-10 h-16 w-11/12 border border-x-2 border-y-2 px-9 text-2xl focus:outline-none"
      type="name"
      name={props.title}
      value={Data}
      onChange={(e) => {
        setData({ ...fullData, Data: e.target.value });
      }}
      id="your_name"
      placeholder={props.title}
    />
  );
};

export default LeftContactInputSection1;

// toh error issi file m hih  teeno file ki keh rha m
